<template>
  <div class="wrapper">
    <div class="bar" :style="{'width': width}"></div>
  </div>
</template>

<script>
export default {
  props: ['width']
}
</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    width: 100%;
    height: 7px;
    background: #F4F4F4;
    border-radius: 4px;

    .bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-image: linear-gradient(90deg, #FF9F79, #FF6644);
      border-radius: 4px;
    }
  }
</style>
